//  ####     #####   ###    ###            ####    #####  ##
//  ##  ##  ##   ##  ## #  # ##            ##  ##  ##     ##
//  ##  ##  ##   ##  ##  ##  ##  ########  ##  ##  #####  ##
//  ##  ##  ##   ##  ##      ##            ##  ##  ##     ##
//  ####     #####   ##      ##            ####    #####  ######
/*
.js-destroyParentを押すと親の.js-destroyParent-frameを消す
<div class="js-destroyParent-frame">
  <button type="button" class="js-destroyParent">
    削除
  </button>
</div>
*/
window.addEventListener('click', function (e) {
  const item = e.target.closest('.js-destroyParent')
  if (!item) {
    return
  }
  applyDestroyParent(item)
})

function applyDestroyParent(item) {
  const target = item.closest('.js-destroyParent-frame')

  if (target) {
    target.parentNode.removeChild(target)
  }

  window.tagBoxSetup() // タグボックスの幅計算
}
